import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appBmPanel]',
})
export class BmPanelDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
